import Vue from 'vue';
import 'vant/lib/index.css';
import { Dialog ,Button, Form, Field, Cell, CellGroup, Toast, Step, Steps, PullRefresh, ImagePreview, Collapse, CollapseItem, NavBar, Icon, Tab, Tabs, Tabbar, TabbarItem, List, Overlay, Loading,Sidebar,SidebarItem } from 'vant'
import { Uploader } from 'vant';


Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Toast);
Vue.use(Step);
Vue.use(Steps);
Vue.use(PullRefresh);
Vue.use(ImagePreview);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(NavBar);
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(List);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Uploader);
Vue.use(Dialog );

 





// WEBPACK FOOTER //
// ./src/components/vant.js